<template>
    <v-row>
        <v-col cols="12">
            <v-row class="mx-sm-1 mx-0 my-sm-2 my-0">
                <v-col cols="12" md="8" sm="10" class="mx-auto">
                    <div v-for="(waiver) in waivers" :key="waiver.id">
                        <v-form ref="formWaiver">
                            <div>
                                <h2 class="text-center">
                                    <p>
                                    {{
                                        $tc("memberRegistration.step_waiver.content.step_header_prefix")
                                    }}
                                    {{ waiver.participantName }} {{ waiver.participantLastname }}
                                    </p>
                                </h2>
                                <h2 class="text-center">{{waiver.displayName }}</h2>
                                <input type="hidden" v-model="waiver.id">
                                {{ /** DOCUMENT MESSAGE */ }}
                                <v-card outlined>
                                    <v-card-text>
                                    <div v-html="waiver.documentMessage"></div>
                                    <v-spacer />
                                <v-checkbox :disabled="waiver.isAgreedChk != null" v-model="waiver.isAgreedChk" 
                                :label="waiver.isAgreedChk ? $t('eventWaiver.signed', language)+' (' + $options.filters.formatDateForHumans(waiver.isAgreedChk,true) + ')' : $t('eventWaiver.signed', language)"
                                @change="updateField('isAgreedChk')"></v-checkbox>                                
                                    </v-card-text>
                                </v-card>

                                <br />

                                {{ /** Participant Information */ }}
                                <v-card outlined>
                                    <v-card-title>
                                    <div>{{ isMinorParticipant(waiver) ? $tc("member_registration.waiver_participant.minor_information") : $tc("member_registration.waiver_participant.information") }}</div>
                                    </v-card-title>
                                    <v-card-text>
                                    <div>
                                        <span>{{ $tc("member_registration.waiver_participant.name") }}: </span>
                                        <span class="font-weight-bold">{{ waiver.participantName }} {{ waiver.participantLastname }}</span>
                                    </div>
                                    <div v-if="showWaiverAmaNumber(waiver)">
                                        <span>AMA Number: </span>
                                        <span class="font-weight-bold">{{ waiver.validAmaNumber }}</span>
                                    </div>
                                    <div>
                                        <span>{{ $tc("member_registration.waiver_participant.email") }}: </span>
                                        <span class="font-weight-bold">{{ waiver.participantEmail }}</span>
                                    </div>
                                    <div>
                                        <span>{{ $tc("member_registration.waiver_participant.gender") }}: </span>
                                        <span class="font-weight-bold">{{ translateGender(waiver.participantGender) }}</span>
                                    </div>
                                    <div>
                                        <span>{{ $tc("member_registration.waiver_participant.dob") }}: </span>
                                        <span class="font-weight-bold">{{ waiver.participantDateOfBirth | formatDateForHumans(false) }}</span>
                                    </div>
                                    <template v-if="!isMinorParticipant(waiver)">
                                        <v-spacer />
                                        <v-checkbox :disabled="waiver.isCertifyChk != null" v-model="waiver.isCertifyChk" 
                                        :label="$t('eventWaiver.is_correct_information', language, {time: $options.filters.formatDateForHumans(waiver.isCertifyChk,true)})"
                                        @change="updateField('isCertifyChk')"></v-checkbox>
                                    </template>
                                    </v-card-text>
                                </v-card>

                                <br />
                                {{ /** Parent/Guardian Information - shown only for minors */ }}
                                <template v-if="isMinorParticipant(waiver)">
                                <v-card outlined>
                                    <v-card-title>
                                        <div>{{ $tc("member_registration.waiver_participant.signatory_information") }}</div>
                                    </v-card-title>
                                    <v-card-text>
                                        <div>
                                            <span>{{ $t("eventWaiver.current_ip_address", language) }}: </span>
                                            <span class="font-weight-bold">{{ currentIp }}</span>
                                        </div>
                                        <div>
                                            <span>{{ $tc("member_registration.waiver_participant.name") }}: </span>
                                            <span class="font-weight-bold">{{ waiver.signatoryName }} {{ waiver.signatoryLastname }}</span>
                                        </div>
                                        <div>
                                            <span>{{ $tc("member_registration.waiver_participant.email") }}: </span>
                                            <span class="font-weight-bold">{{ waiver.signatoryEmail }}</span>
                                        </div>
                                        <div>
                                            <span>{{ $tc("member_registration.waiver_participant.gender") }}: </span>
                                            <span class="font-weight-bold">{{ translateGender(waiver.signatoryGender) }}</span>
                                        </div>
                                        <div>
                                            <span>{{ $tc("member_registration.waiver_participant.dob") }}: </span>
                                            <span class="font-weight-bold">{{ waiver.signatoryDateOfBirth | formatDateForHumans(false) }}</span>
                                        </div>
                                        <v-spacer />
                                        <v-checkbox :disabled="waiver.isCertifyChk != null" v-model="waiver.isCertifyChk"
                                        :label="guardianConsentLabelFor(waiver)"
                                        @change="updateField('isCertifyChk')"></v-checkbox>
                                    </v-card-text>
                                </v-card>
                                <br />
                                </template>
                                {{ /** Participant Signature */ }}
                                <v-card outlined>
                                    <v-card-title>
                                    <div>{{ hasAdultWaiver ? $tc("member_registration.waiver_participant.racers_signature_adult") : $tc("member_registration.waiver_participant.racers_signature_minor") }}</div>
                                    </v-card-title>
                                    <v-card-text>
                                    <v-row class="align-center" v-if="signature.signatureUUID && signature.signatureImage">
                                            <v-col md="11" sm="11" cols="12" class="text-left">
                                            <v-img max-height="200" max-width="700" :src="getSignatureImage(signature)"></v-img>
                                            </v-col>
                                    </v-row>
                                    <v-dialog v-model="dialog" max-width="750">
                                        <template v-slot:activator="{ on, attrs }">
                                        <v-btn color="primary" dark v-bind="attrs" v-on="on">
                                            {{ $tc("member_registration.waiver_participant.sign_now") }}
                                            <v-icon style="padding-left:10px">fa fas fa-signature</v-icon>
                                        </v-btn>
                                        </template>
                                        <StepWaiverSignature 
                                            ref="signaturesRef"
                                            :waiver="waiver" 
                                            :signatures="signatures" 
                                            :urlDomain="urlDomain"
                                            :loadingSignatures="loadingSignatures" 
                                            :dialog="dialog" 
                                            @setSignature="setSignature"
                                            @getSignatures="getSignatures"
                                            @closeDialog="closeDialog" />
                                        </v-dialog>
                                    </v-card-text>
                                </v-card>

                                <br />
                                {{ /** Electronic Signature Consent */ }}
                                <v-card outlined>
                                    <v-card-title>
                                    <div>{{ $tc("eventWaiver.electronic_signature_consent") }}</div>
                                    </v-card-title>
                                    <v-card-text>
                                    <div v-html="waiver.electronicConsent"></div>
                                    <v-spacer />
                                <v-checkbox :disabled="waiver.isElectronicConsentChk != null" v-model="waiver.isElectronicConsentChk" 
                                :label="waiver.isElectronicConsentChk ? $t('eventWaiver.signed', language) + ' (' + $options.filters.formatDateForHumans(waiver.isElectronicConsentChk,true) + ')' : $t('eventWaiver.signed', language)"
                                @change="updateField('isElectronicConsentChk')"></v-checkbox>
                                    </v-card-text>
                                </v-card>
                            </div>
                        </v-form>
                    </div>
                </v-col>
                <v-col cols="12" >   
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                        :color="buttonColor"
                        class="white--text"
                        @click="logout"
                        >
                        {{$t("layouts.login.logout",language)}}
                        </v-btn>
                        <v-btn
                        :color="buttonColor"
                        class="white--text"
                        @click="nextSignItem('Rejected')"
                        >
                        {{$t("eventWaiver.reject",language)}}
                        </v-btn>
                        <v-btn
                        :color="buttonColor"
                        class="white--text"
                        @click="nextSignItem('Signed')"
                        :disabled="isSingDisabled"
                        >
                        {{$t("eventWaiver.signed",language)}}
                        </v-btn>
                    </v-card-actions>
                </v-col>
            </v-row>
        </v-col>
        <div class="sn1">
            <Snack :snack="snackbar" :snackMsg="msg_snackbar" :snackCol="color_snackbar"/>
        </div>

    </v-row>
</template>

<script>
import {
    VRow, VCol, VDialog, VCard, VIcon, VBtn, VCardText, VCardTitle, VCheckbox, VSpacer, VImg, VCardActions, VForm
} from 'vuetify/lib';
import LoginService from "@/services/LoginService";
import Snack from "@/components/notifications/Snack";
import axios from "axios";
import APIService from "@/services/APIService";
import StepWaiverSignature from "@/components/memberRegistration/Step_WaiverSignature.vue";

export default {
    components: {
        VRow, VCol, Snack, StepWaiverSignature, VDialog, VCard, VIcon, VBtn, VCardText, VCardTitle, VCheckbox, VSpacer, VImg, VCardActions, VForm
    },
    props: {
        waivers: {
            type: [Object, Array]
        },
        // AMA Waiver Bypass v2 — relationships captured by
        // Main.vue's ParentGuardianDialog pre-check, keyed by minor
        // user id. Used to personalize the consent label and forward
        // signatoryRelationship on sign. Blocked minor ids come in so
        // this component can refuse to sign those rows locally.
        relationshipByMinor: {
            type: Object,
            default: () => ({})
        },
        blockedMinorIds: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            currentSlide: 0,
            waiverList: [],
            bandApprove: false,
            index: 0,
            bandType: "",
            snackbar: false,
            msg_snackbar: "",
            color_snackbar: "",
            currentIp: "",
            waiverItemIndex: false,
            languageWaiver: 'en',
            waiverId: 0,
            //waivers: [],
            checkbox: {
                isAgreedChk: {
                status: false,
                updatedAt: null
                },
                isCertifyChk: {
                status: false,
                updatedAt: null
                },
                isElectronicConsentChk: {
                status: false,
                updatedAt: null
                },
            },
            signature: {
                signatureUUID: null,
                signatureImage: null,
                signatureId: null
            },
            loadingSignatures: false,
            signatures: null,
            dialog: false,
            defaultSignature: null,
        }
    },
    computed: {
        hasAdultWaiver() {
            let waiver = this.waivers[this.currentSlide];
            if (!waiver || !waiver.participantDateOfBirth) return false;
            return !this.isMinorParticipant(waiver);
        },
        urlDomain(){
            return this.$store.getters.env.get('VUE_APP_DEV_API_HOST');
        },
        isSingDisabled() {
            const currentWaiver = this.waivers[this.currentSlide];
    
            return !currentWaiver.isAgreedChk ||
            !currentWaiver.isCertifyChk ||
            !currentWaiver.isElectronicConsentChk ||
            !this.signature.signatureUUID ||
            !this.signature.signatureImage ||
            !this.signature.signatureId;
        },
        /**
         * Determines the appropriate language code for the waiver item.
         *
         * This function checks if the waiver item content is available in the current locale.
         * If the content is unavailable, it defaults to the first available content language code if provided.
         *
         * @returns {string} The language code to be used.
         */
        language() {
            // Get the current locale
            let language = this.$i18n.locale;

            // Return early if waiverItemIndex or content is missing
            if (!this.waiverItemIndex || !this.waiverItemIndex.content) {
                return language;
            }

            // Check if content in the current language is available, otherwise default to firstContent
            const contentForLanguage = this.waiverItemIndex.content[language];
            if (contentForLanguage && Object.prototype.hasOwnProperty.call(contentForLanguage, 'available') && !contentForLanguage.available) {
                language = this.firstContent ? this.firstContent.languageCode : language;
            }

            return language;
        },

        /**
         * Returns a human-readable date label for the "I Agree" time, if available.
         *
         * This function formats `timeIAgree` using the `formatDateForHumans` filter if `timeIAgree` has a value.
         * If `timeIAgree` is not set, it simply returns `timeIAgree` as is (likely null or undefined).
         *
         * @returns {string|null|undefined} The formatted date or the original value of `timeIAgree`.
         */
        timeIAgreeLabel() {
            if (!this.timeIAgree) return this.timeIAgree;
            return this.$options.filters.formatDateForHumans(this.timeIAgree);
        },

        /**
         * Returns a human-readable date label for the "Is Correct Minor" time, if available.
         *
         * This function formats `timeIsCorrectMinor` using the `formatDateForHumans` filter if `timeIsCorrectMinor` has a value.
         * If `timeIsCorrectMinor` is not set, it simply returns `timeIsCorrectMinor` as is.
         *
         * @returns {string|null|undefined} The formatted date or the original value of `timeIsCorrectMinor`.
         */
        timeIsCorrectMinorLabel() {
            if (!this.timeIsCorrectMinor) return this.timeIsCorrectMinor;
            return this.$options.filters.formatDateForHumans(this.timeIsCorrectMinor);
        },

        /**
         * Returns a human-readable date label for the "Is Consent" time, if available.
         *
         * This function formats `timeIsConsent` using the `formatDateForHumans` filter if `timeIsConsent` has a value.
         * If `timeIsConsent` is not set, it simply returns `timeIsConsent` as is.
         *
         * @returns {string|null|undefined} The formatted date or the original value of `timeIsConsent`.
         */
        timeIsConsentLabel() {
            if (!this.timeIsConsent) return this.timeIsConsent;
            return this.$options.filters.formatDateForHumans(this.timeIsConsent);
        },

        buttonColor() {
            return this.$store.getters.env.get('VUE_APP_BUTTON_COLOR') || '#000';
        },
    },
    created() {
        this.getIP();
        this.getSignatures();
        this.resetStalePreSignChecks();
    },
    methods: {
        /**
         * updateOrganizationWaiverSigned persists each checkbox click
         * independently of signing, so a row can end up with
         * isAgreedChk / isCertifyChk / isElectronicConsentChk
         * timestamps while waiverStatus stays "NotSigned" and
         * fkUserSignatureId stays null (user checked the boxes, then
         * abandoned). On re-render that looks like the boxes were
         * already ticked "by a ghost", with no way to uncheck because
         * :disabled="waiver.isAgreedChk != null" greys them out.
         *
         * Reset those stale timestamps on the local waiver objects so
         * the UI starts fresh for anything not actually signed. The
         * backend values get rewritten the moment the user re-checks
         * a box (updateField calls updateOrganizationWaiverSigned with
         * a new timestamp).
         */
        resetStalePreSignChecks() {
            if (!Array.isArray(this.waivers)) return;
            for (const w of this.waivers) {
                if (!w) continue;
                if (w.waiverStatus === 'Signed') continue;
                if (w.fkUserSignatureId) continue;
                if (w.isAgreedChk) w.isAgreedChk = null;
                if (w.isCertifyChk) w.isCertifyChk = null;
                if (w.isElectronicConsentChk) w.isElectronicConsentChk = null;
            }
        },
        // Personalized guardian consent label — mirrors the one built in
        // Step_WaiverParticipant so the rendered signed waiver shows the
        // exact declaration the signatory made. Relationship and minor
        // identity are persisted on the waiver row
        // (signatoryRelationship + fkUserId/participantName), so this
        // label is reconstructable for any audit.
        guardianConsentLabelFor(waiver) {
            const time = this.$options.filters.formatDateForHumans(waiver.isCertifyChk, true);
            const relCode = waiver && waiver.signatoryRelationship;
            if (relCode) {
                const minorName = `${waiver.participantName || ""} ${waiver.participantLastname || ""}`.trim();
                if (relCode === "Guardian") {
                    return this.$t(
                        "member_registration.waiver_participant.guardian_consent_guardian",
                        this.language,
                        { minorName, time }
                    );
                }
                if (relCode === "Father" || relCode === "Mother") {
                    const relKey = relCode === "Father"
                        ? "memberRegistration.parent_guardian.father"
                        : "memberRegistration.parent_guardian.mother";
                    return this.$t(
                        "member_registration.waiver_participant.guardian_consent_parent",
                        this.language,
                        { relationship: this.$t(relKey, this.language), minorName, time }
                    );
                }
            }
            // Fallback (no relationship captured on the waiver row) — use
            // the generic wording with the minor's name so the dashboard
            // popup matches the personalized versions.
            const minorName = `${waiver.participantName || ""} ${waiver.participantLastname || ""}`.trim();
            return this.$t("member_registration.waiver_participant.guardian_consent", this.language, { minorName, time });
        },
        showWaiverAmaNumber(waiver) {
            const memberType = waiver && waiver.organizationMemberType ? waiver.organizationMemberType : null;
            const requiresAma = Number((memberType && (memberType.isRequireAMA || memberType.requiresValidAma)) || 0) === 1;
            return requiresAma && !!(waiver && waiver.validAmaNumber);
        },
        isMinorParticipant(waiver) {
            if (!waiver || !waiver.participantDateOfBirth) return false;
            const adultAge = Number(waiver.adultAge || 18);
            const bd = new Date(waiver.participantDateOfBirth);
            const today = new Date();
            let age = today.getFullYear() - bd.getFullYear();
            const m = today.getMonth() - bd.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < bd.getDate())) age--;
            return age < adultAge;
        },
        translateGender(gender) {
            const rawValue = (gender || "").toString().trim();
            if (!rawValue) return rawValue;

            const normalized = rawValue.toLowerCase();
            const genderKeyMap = {
                male: "registration.male",
                m: "registration.male",
                masculino: "registration.male",
                hombre: "registration.male",
                homme: "registration.male",
                female: "registration.female",
                f: "registration.female",
                femenino: "registration.female",
                mujer: "registration.female",
                femme: "registration.female",
                other: "common.other",
                o: "common.other",
                otro: "common.other",
                autre: "common.other",
            };

            const key = genderKeyMap[normalized];
            return key ? this.$t(key, this.language) : rawValue;
        },
        getSignatureImage(signature) {
            return "data:image/png;base64," + signature.signatureImage;
        },
        async updateField(checkName){
            this.waivers[this.currentSlide][checkName] = this.getTimeStamp();            
            const path = `${this.$store.getters.env.get('VUE_APP_ROOT')}/laravel/public/api/v1/participant/organization/waiver/check`;
            const data = { 
                id: this.waivers[this.currentSlide].id,
                checkName: checkName,
                value: this.getTimeStamp()
            }

            await APIService.fetch({
                method: "post",
                path: path,
                data
            })
        },
        async signDocument(id) {
            // AMA Waiver Bypass v2 — forward the relationship captured
            // in Main.vue's ParentGuardianDialog pre-check so the
            // backend persists it on
            // organizationWaiverSigned.signatoryRelationship. If the
            // adult blocked this minor, refuse.
            const w = Array.isArray(this.waivers) ? this.waivers[this.currentSlide] : null;
            let signatoryRelationship = null;
            if (w && this.isMinorParticipant(w)) {
                const minorId = Number(w.participantId || w.fkUserId || w.userId || 0);
                if (minorId && this.blockedMinorIds.includes(minorId)) {
                    this.snackbar = true;
                    this.color_snackbar = "error";
                    this.msg_snackbar = this.$t("memberRegistration.parent_guardian.blocked_message");
                    return;
                }
                signatoryRelationship = (minorId && this.relationshipByMinor && this.relationshipByMinor[minorId]) || w.signatoryRelationship || null;
            }

            const path = `${this.$store.getters.env.get('VUE_APP_ROOT')}/laravel/public/api/v1/participant/organization/waiver/sign`;
            const data = {
                id: id,
                signatureId: this.signature.signatureId,
                signatoryRelationship: signatoryRelationship
            }

            await APIService.fetch({
                method: "post",
                path: path,
                data
            }).then((resp) => {
                if (resp.data.success){
                   this.$emit('getOrganizationWaiverSigned');
                   this.waivers.length > 1 ? this.currentSlide++ : this.$emit('nextSignItem')
                }
            });

        },
        async getSignatures(){
            this.loadingSignatures = true;
            this.signatures = [];
            const path = `${this.urlDomain}/laravel/public/api/v1/participant/signatures`;
            await APIService.fetch({
                method: "get",
                path: path,
            })
            .then((resp) => {
                if (resp.data.success) {
                    this.signatures = resp.data.message;
                }
                this.loadingSignatures = false;
            })
            .catch(function () {
                this.loadingSignatures = false;
            });
        },
        setSignature(signature){
            this.signature = {}
            this.signature.signatureId = signature.signatureId;
            this.signature.signatureImage = signature.signatureImage;
            this.signature.signatureUUID = signature.signatureUUID;
        },
        async getOrganizationWaiverSigned() {
            const data = {
                organizationId: 50,
                participants: [this.$store.state.session.user.id],
                ipAddress: this.currentIp
            };

            await APIService.fetch({
                method: "post",
                path: `${this.urlDomain}/laravel/public/api/v1/participant/organization/waiver/signed`,
                data                
            }).then((resp) => {
                if (resp.data.success){
                    this.waivers = resp.data.message
                }
            });
        },    
        getIP() {
            fetch(`${this.urlDomain}/laravel/public/api/v1/users/current/currentIp`)
            .then(x => x.json())
            .then(({ message }) => {
                this.currentIp = message;
            });
        },
        async logout() {
            LoginService.logout().then(response => {
                if(response.data.success == 1){
                if (typeof this.oldSystem === "undefined"){
                    this.$router.push({ name: 'Login' });
                } else {
                    window.location.href = this.$store.getters.env.get('VUE_APP_DEV_API_HOST')+'/login?message=You20are%20logged%20out!';
                }
                }
            });
        },
        showSnackBar(message, color){
            this.snackbar = true;
            this.msg_snackbar = message;
            this.color_snackbar = color;
            setTimeout(() => this.snackbar = false, 3000);
        },
        next(waiverStatus) {
            let bandNext = false;
            if(this.$refs.waiverYou) {
                bandNext = this.$refs.waiverYou.nextSign();
            }
            if(!bandNext) {
                this.snackbar = true;
                this.msg_snackbar = this.$tc("eventWaiver.invalid_step_4");
                this.color_snackbar = "error";
                setTimeout(() => this.snackbar = false, 3000);
                return;
            }else{
                this.nextSignItem(waiverStatus)
            }
        },
        /**
         * Processes the next waiver signing item by submitting the waiver status and other required information.
         *
         * This function creates a FormData object with necessary waiver details, sends it via an axios request,
         * and emits a `nextSignItem` event upon successful submission.
         *
         * @param {string} waiverStatus - The status of the waiver (e.g., "Signed").
         */
        async nextSignItem(waiverStatus) {
            if (!waiverStatus) return;

            const _waiver = this.waivers[this.currentSlide];

            const submitUpdate = async () => {
                const data = new FormData();
                const waiverForm = this.$refs.formWaiver;

                data.append("eventWaiverSignedId", _waiver.id);
                data.append("waiverStatus", waiverStatus);
                data.append("ipAddress", this.currentIp);

                if (waiverStatus === 'Signed') {
                    data.append("iAgree", _waiver.isAgreedChk);
                    data.append("isCertify", _waiver.isCertifyChk);
                    data.append("isConsent", _waiver.isElectronicConsentChk);
                    data.append("signature", this.signature);

                    if (waiverForm.isPictureRequired) {
                        data.append("selfie", waiverForm.selfie);
                    }
                }

                try {
                    const response = await axios.put(`${this.urlDomain}/laravel/public/api/v1/participant/organization/waiver/signed`, data, { headers: { "content-type": "multipart/form-data" } });
                    if (response.data.success) {
                        this.$emit('nextSignItem');
                    } else {
                        this.showSnackBar(this.$tc("common.error_general"), "error");
                    }
                } catch (error) {
                    this.showSnackBar(this.$tc("common.error_general"), "error");
                }
            };

            if (waiverStatus === 'Rejected') {
                await submitUpdate();
                return;
            }

            const path = `${this.$store.getters.env.get('VUE_APP_ROOT')}/laravel/public/api/v1/participant/organization/waiver/sign`;
            await APIService.fetch({
                method: "post",
                path: path,
                data: { id: _waiver.id, signatureId: this.signature.signatureId }
            }).then(submitUpdate);
        },

        backWaiver() {
            if(this.index > 0) this.index--;
        },
        closeDialog() {
         this.dialog = false;
        },
        getTimeStamp() {
            const now = new Date();
            let month = now.getMonth() + 1;
            month = month < 10 ? `0${month}` : month;
            let day = now.getDate() < 10 ? `0${now.getDate()}` : now.getDate();

            return `${now.getFullYear()}-${month}-${day} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
        },
    },
    watch: {
        waiverItemIndex(val) {
            const waiver = this.$refs.waiverYou; 
            if(waiver && waiver.$refs.formWaiver) {
                waiver.$refs.formWaiver.resetValidation();
                waiver.loadData(val);
            }
                
        },
        waivers(val) {
            // Fresh list from parent (e.g. after advancing to the next
            // waiver or after a refresh) — strip any stale pre-sign
            // check timestamps so the user re-acknowledges before
            // signing. Safe no-op on rows that are already Signed or
            // have a signature attached.
            this.resetStalePreSignChecks();
            if(val) {
                const item = this.waiverList.find((el1) => {
                    return val.fkEventWaiverSId == el1.eventWaiverSId;
                });
                if(!item) {
                    this.waiverList.push({
                        ...val,
                        statusReview: val.waiverStatus == "Signed"
                    });
                }
                if(this.index >= 0 && this.index < this.waiverList.length) {
                    const birthdayCurrent = this.waiverList[this.index].participantDateOfBirth;
                    if(birthdayCurrent) {
                            if(this.waiverList[this.index].ageTarget == "Adult") {
                                this.bandType = 'Adult';
                            } else {
                                this.bandType = 'Minor';
                            }
                    } else {
                            this.bandType = 'Adult';
                    }
                    this.waiverItemIndex = this.waiverList[this.index];
                    if(this.waiverItemIndex) {
                        this.languageWaiver = this.waiverItemIndex.languageCode ? this.waiverItemIndex.languageCode : null;
                    }
                }
            }
        },        
    }
}
</script>